import { uid } from '../../../../lib/uid';
import type { OrgUnitOption } from '../../organization/organizationTypes';
import type { RecruitmentUserOption } from '../../vacancies/vacancyTypes';

/*
  Synthetic, and suffixed: a category name is unique among live rows, so two generated in one
  sitting must not collide. Nothing here lands in the identity store — a reviewer is an account
  picked from the LIVE list, never one the generator invents.
*/
const DOCUMENTS: { name: string; description: string }[] = [
  { name: 'Clearance', description: 'Signed by every office the employee holds property or accountabilities with.' },
  { name: 'Letter of intent', description: 'The employee’s own letter, dated and signed.' },
  { name: 'Service record', description: 'Certified true copy from the records office.' },
  { name: 'Medical certificate', description: 'Issued by a licensed physician within the last 30 days.' },
];

function pick<T>(items: readonly T[]): T | undefined {
  return items.length === 0 ? undefined : items[Math.floor(Math.random() * items.length)];
}

/**
 * A category with two or three documents, each reviewed by a LIVE account, and up to two LIVE org
 * units to clear the employee — distinct, so the server has nothing to collapse. With no account
 * loaded the reviewer stays empty rather than inventing an id, and the form says why it cannot save.
 */
export function sampleAttritionCategory(users: RecruitmentUserOption[], units: OrgUnitOption[] = []) {
  const count = 2 + Math.floor(Math.random() * 2);

  return {
    name: `Sample category ${uid().slice(0, 6)}`,
    description: 'Sample category. Delete it once the real ones are in.',
    documents: DOCUMENTS.slice(0, count).map((document) => ({
      name: document.name,
      description: document.description,
      reviewerUserId: pick(users)?.userId ?? null,
    })),
    clearances: [...units]
      .sort(() => Math.random() - 0.5)
      .slice(0, 2)
      .map((unit) => ({ orgUnitId: unit.id, signatoryUserId: pick(users)?.userId ?? null })),
  };
}
